import BaseModel from '../core/BaseModel'

export default class NotificationsModel extends BaseModel {

    constructor() {
        super({
            tableName: 'notification', label: "Notification", display_key: 'id'
        }, {
            stt: { 
                name: "stt", 
                label: "No.", 
                class: 'center', 
                computed: (data, index) => {
                    data.stt = index + 1;
                }
            },
            id: { 
                name: 'id', 
                type: "Bigint", 
                label: 'ID', 
                primaryKey: true,  
                display: false
            },
            type_id: {
                name: "type_id",
                label: "Type",
                type: "Selection",
                width : 6,
                class:"medium-col txt-left",
                options: [
                    {value: 1, label: 'Important', key : 'ALL',style: 'color:  #000000;'},
                    {value: 2, label: 'Promotion', key : 'USER',style: 'color:  #000000;'}
                ],
                filter: {
                    type: 'select',
                    optionLabel: 'label',
                    optionKey: 'value',
                    match: 'equals'
                },
                //display:false
            },
            type: {
                name: "type",
                label: "Receiver",
                type: "Selection",
                width : 6,
                class:"medium-col txt-left",
                options: [
                    {value: 'ALL', label: 'All users', key : 'ALL',style: 'color:  #000000;'},
                    {value: 'ONE', label: 'Users', key : 'USER',style: 'color:  #000000;'},
                    {value: 'ALL_RENTER', label: 'All renters', key : 'USER',style: 'color:  #000000;'},
                    {value: 'MULTIL_LOYALTY', label: 'Loyalty level', key : 'USER',style: 'color:  #000000;'}
                ],
                filter: {
                  type: 'select',
                  optionLabel: 'label',
                  optionKey: 'value',
                  match: 'equals'
                },
                //display:false
            },
            title : {
                name: 'title',
                type: "Text", 
                label: 'Title',
                class:"medium-col txt-left",
                filter: {type: 'input', match: 'contains'},
                computed: (data) => {
                  data.title = '';
                },
            },
            short_content : {
                name: 'short_content',
                type: "Text", 
                label: 'Short description',
                filter: {type: 'input', match: 'contains'},
                class:"large-col txt-left",
                computed: (data) => {
                  data.short_content = '';
                },
                //display:false
            },
            created_at: { 
                name: 'created_at', 
                type: "Datetime", 
                width: 15,
                label: 'Created date',
                class:"center txt-small-col-midle txt-left",
               // filter: { type: 'DateRange', match: 'contains'},
            },
            updated_at: {
                name: 'updated_at',
                type: "Datetime",
                width: 15,
                label: 'Updated date',
                class:"center txt-small-col-midle txt-left",
               /// filter: { type: 'DateRange', match: 'contains'},
            },
            rel_lang: {
                refs: `multi_loyalty_id type_id screen action_key webview_url is_push is_admin active deleted uid type_id object_id created_at updated_at id_table multi_uid data app_type clubs_user key_noti    notification_lang { id lang title content short_content id_table id_lang notification_id short_content_noti }`,
                display: false
            },

        })
    }

}